export const DS_IMAGE_TYPE = {
  jpeg: 'image/jpeg',
  png: 'image/png',
};
